// extracted by mini-css-extract-plugin
module.exports = {"container":"InverstorFAQs_container__rSvI-","content":"InverstorFAQs_content__1QVEa","mainContent":"InverstorFAQs_mainContent__1g1Hb","bordered":"InverstorFAQs_bordered__19TKW"};